export const PROFILE_PERSONAL_INFO_INHABITANT_DATA = {
  full_name: 'Ayden Dominic Alejandro Carrillo',
  gdpr_info:
    'The individual has explicitly requested that all personal communication be conducted in compliance with GDPR regulations and stored only for the legally required retention period.',
  middle_name: 'Dominic Alejandro',
  name_info: 'Ayden Carrillo, PhD, MSc, BSc (Hons)',
  notes:
    'Customer prefers detailed written communication and usually responds within one business day. Has previously requested that appointments be scheduled at least 48 hours in advance.',
  preferred_communication: { id: 1, value: 'Email' },
  salutation: { id: 179, salutation: 'Sehr geehrter Herr' },
  status: { id: 367, value: 'With child' },
  title:
    'Doctor of Philosophy (PhD) in Computer Science, Master of Science (MSc) in Artificial Intelligence and Distributed Systems',
}

export const PROFILE_PERSONAL_INFO_INHABITANT_FIELD_VARIABLES = {
  full_name: [
    {
      description: 'RecipientInfoFullName',
      label: '{{recipient_info_full_name}}',
      name: 'recipient_info_full_name',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoFullName',
      label: '{{request_customer_info_full_name}}',
      name: 'request_customer_info_full_name',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  gdpr_info: [
    {
      description: 'RecipientInfoGdprInfo',
      label: '{{recipient_info_gdpr_info}}',
      name: 'recipient_info_gdpr_info',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoGdprInfo',
      label: '{{request_customer_info_gdpr_info}}',
      name: 'request_customer_info_gdpr_info',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  middle_name: [
    {
      description: 'RecipientInfoMiddleName',
      label: '{{recipient_info_middle_name}}',
      name: 'recipient_info_middle_name',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoMiddleName',
      label: '{{request_customer_info_middle_name}}',
      name: 'request_customer_info_middle_name',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  name_info: [
    {
      description: 'RecipientInfoNameInfo',
      label: '{{recipient_info_name_info}}',
      name: 'recipient_info_name_info',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoNameInfo',
      label: '{{request_customer_info_name_info}}',
      name: 'request_customer_info_name_info',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  preferred_communication: [
    {
      description: 'RecipientInfoPreferredCommunication',
      label: '{{recipient_info_preferred_communication}}',
      name: 'recipient_info_preferred_communication',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoPreferredCommunication',
      label: '{{request_customer_info_preferred_communication}}',
      name: 'request_customer_info_preferred_communication',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  salutation: [
    {
      description: 'RecipientInfoSalutation',
      label: '{{recipient_info_salutation}}',
      name: 'recipient_info_salutation',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoSalutation',
      label: '{{request_customer_info_salutation}}',
      name: 'request_customer_info_salutation',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  status: [
    {
      description: 'RecipientInfoStatus',
      label: '{{recipient_info_status}}',
      name: 'recipient_info_status',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoStatus',
      label: '{{request_customer_info_status}}',
      name: 'request_customer_info_status',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
  title: [
    {
      description: 'RecipientInfoTitle',
      label: '{{recipient_info_title}}',
      name: 'recipient_info_title',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'mass_emailing',
        'external_templates',
      ],
    },
    {
      description: 'RequestCustomerInfoTitle',
      label: '{{request_customer_info_title}}',
      name: 'request_customer_info_title',
      used_in: [
        'request_comment',
        'manager_email',
        'request_feedback',
        'requestthread_email',
        'external_templates',
      ],
    },
  ],
}
